import React from "react";

interface Props {
  balance: string;
}

const WalletInfo = ({ balance }: Props) => {
  return (
    <div className="flex px-3 py-2 mt-4 bg-white rounded-md shadow">
      <div className={`flex mx-auto items-center justify-center bg-pkc-primary-15 btn-circle `}>
        <i className={`far fa-wallet fa-lg my-auto text-pkc-primary`} />
      </div>
      <div className="flex items-center justify-between flex-1 pr-3 ml-1 mr-auto">
        <p className="text-xs font-normal text-pkc-description-text">موجودی کیف پول شما</p>
        <div className="flex">
          <p className="text-xl font-bold text-pkc-dark-blue">{Number(balance).toLocaleString()}</p>
          <p className="mr-2 text-base font-bold text-pkc-description-text ">تومان</p>
        </div>
      </div>
    </div>
  );
};

export default WalletInfo;
